import React, { useState, useEffect } from "react";
import images from "../images/data1";
import ReactModal from "react-modal";
import { FiChevronRight, FiChevronLeft, FiChevronDown } from "react-icons/fi";
import { BsXCircle } from "react-icons/bs";
import { Waypoint } from "react-waypoint";

function Portfolio() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [photos, setPhotos] = useState(images);
  const [showSlider, setShowSlider] = useState(false);
  const [displayedPhotos, setDisplayedPhotos] = useState(photos.slice(0, 12));
  const [isLoading, setIsLoading] = useState(false);
  const [animate, setAnimate] = useState("");
  const [animateRight, setAnimateRight] = useState("");

  function showMore() {
    if (displayedPhotos.length >= photos.length) {
      return;
    }

    setDisplayedPhotos(
      displayedPhotos.concat(
        photos.slice(displayedPhotos.length, displayedPhotos.length + 6)
      )
    );
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }

  useEffect(() => {
    const lastIndex = images.length - 1;
    if (currentIndex < 0) {
      setCurrentIndex(lastIndex);
    }
    if (currentIndex > lastIndex) {
      setCurrentIndex(0);
    }
  }, [currentIndex, photos]);

  function handleSlider(index) {
    setCurrentIndex(index);
    setShowSlider(true);
  }

  const handleWaypointEnter = () => {
    setAnimate("visible animate__animated animate__backInUp");
  };
  const handleWaypointEnterRight = () => {
    setAnimateRight("visible animate__animated animate__fadeInRight");
  };

  return (
    <section className="portfolio" id="work">
      <div className="container">
        <div className="row">
          <div className="container">
            <Waypoint onEnter={handleWaypointEnterRight}>
              <div className={`section-title hide ${animateRight}`}>
                <h1 className="title">Portfolio</h1>
                <h1 className="title title-fill">My</h1>
              </div>
            </Waypoint>
          </div>

          {displayedPhotos.map((image, index) => (
            <Waypoint onEnter={handleWaypointEnter}>
              <div
                className={`col-lg-4 portfolio-item hide ${animate}`}
                key={index}
              >
                <figure>
                  <img
                    onClick={() => handleSlider(index)}
                    className="img-fluid"
                    src={image.src}
                    alt={image.alt}
                  />
                </figure>
              </div>
            </Waypoint>
          ))}

          {isLoading ? <div class="loader"></div> : null}

          {displayedPhotos.length < photos.length && (
            <button onClick={showMore} className="load-more">
              <span>Load More</span>
              <FiChevronDown className="animate__animated animate__bounce" />
            </button>
          )}
        </div>

        <ReactModal
          isOpen={showSlider}
          onRequestClose={() => setShowSlider(false)}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
            content: {
              backgroundColor: "white",
              position: "absolute",
              top: "50%",
              left: "50%",
              right: "auto",
              overflow: "hidden",
              padding: "0",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              height: "80%",
            },
          }}
        >
          <div className="portfolio-slider">
            {photos.map((photo, photoIndex) => {
              const { id, src } = photo;

              let position = "nextSlide";
              if (photoIndex === currentIndex) {
                position = "activeSlide";
              }
              if (
                photoIndex === currentIndex - 1 ||
                (currentIndex === 0 && photoIndex === photos.length - 1)
              ) {
                position = "lastSlide";
              }

              if (photoIndex === currentIndex) {
                return (
                  <article className={position} key={id}>
                    <a href={src} target="blank">
                      <img
                        src={src}
                        alt=""
                        className={`${position} animate__animated animate__fadeIn`}
                      />
                    </a>
                  </article>
                );
              }
            })}

            <div className="controls">
              <button
                className="prev"
                onClick={() => setCurrentIndex(currentIndex - 1)}
              >
                <FiChevronLeft />
              </button>
              <button
                className="next"
                onClick={() => setCurrentIndex(currentIndex + 1)}
              >
                <FiChevronRight />
              </button>
            </div>
            <div className="close-icon">
              <BsXCircle onClick={() => setShowSlider(false)} />
            </div>
          </div>
        </ReactModal>
      </div>
    </section>
  );
}

export default Portfolio;
